export function getTimelineConflicts(items) {
  const conflicts = [];
  const timedItems = items
    .map((item, index) => ({
      item,
      index,
      minutes: toMinutes(item.time)
    }))
    .filter(({ minutes }) => minutes !== null);

  const timeGroups = new Map();

  timedItems.forEach(({ item, index, minutes }) => {
    const group = timeGroups.get(minutes) || [];
    group.push({ item, index });
    timeGroups.set(minutes, group);
  });

  timeGroups.forEach((group) => {
    if (group.length > 1) {
      conflicts.push({
        id: `duplicate-${group[0].item.id}`,
        type: 'duplicate',
        indexes: group.map(({ index }) => index),
        message: `“${group.map(({ item }) => item.name).join('” and “')}” share the same time.`
      });
    }
  });

  timedItems.slice(1).forEach(({ item, index, minutes }, position) => {
    const previous = timedItems[position];

    if (minutes < previous.minutes) {
      conflicts.push({
        id: `order-${item.id}`,
        type: 'order',
        indexes: [previous.index, index],
        message: `“${item.name}” starts before “${previous.item.name}”.`
      });
    }
  });

  return conflicts;
}

function toMinutes(value) {
  if (!value) return null;

  const [hours, minutes] = value.split(':').map(Number);

  if (
    Number.isNaN(hours) ||
    Number.isNaN(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return null;
  }

  return hours * 60 + minutes;
}